import { actionTypes } from '../constants/actionTypes';

export const translations = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_TRANSLATIONS:
      return action.translationsData;
    default:
      return state;
  }
};
  
export const privacyPolicyLink = (state = '', action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PRIVACY_POLICY_LINK:
      return action.link;
    default:
      return state;
  }
};
  
export const locale = (state = '', action) => {
  switch (action.type) {
    case actionTypes.UPDATE_LANGUAGE_LOCALE:
      return action.locale;
    default:
      return state;
  }
};